/** @jsxImportSource @emotion/react */

import { FieldProps, useFormikContext } from 'formik';

import { css, SerializedStyles } from '@emotion/react';

import { InputThemeVariant } from '../';
import { localeNO } from '../../../utils/localeNO';

/**
 * Ensures that typed/pasted text can be properly parsed to `Number` and then
 * localized.
 * 1. Replace every `,` with `.` - comma breaks Number parsing
 * 2. Removes all spaces
 * 3. Removes every dot but last one
 */
const parseInputValue = (value: string) =>
    value
        .replace(/,/g, '.')
        .replace(/\s/g, '')
        .replace(/[.](?=.*[.])/g, '');

export const InputNumberLocale = ({
    form,
    field,
    meta,
    ...restProps
}: FieldProps) => {
    const { setFieldValue } = useFormikContext();

    return (
        <input
            type="number"
            css={InputVariants['ghostRounded']}
            {...field}
            {...restProps}
            onBlur={(event) =>
                setFieldValue(
                    event.target.name,
                    parseFloat(event.target.value).toLocaleString('nb-NO'),
                )
            }
        />
    );
};

const InputVariants: Record<InputThemeVariant, SerializedStyles> = {
    ghostRounded: css`
        border: 1px solid #000000;
        padding: 15px 20px;
        border-radius: 50px;
    `,
};
